import { isObjectValid } from "@estaly/ui";
import { format } from "date-fns";

export function formatDate(date, locale) {
  let formattedDate = null;
  if (isObjectValid(date)) {
    formattedDate = new Date(date).toLocaleString(locale);
  }
  return formattedDate;
}

export function formatAnalyticsDate(date, dateFormat = "yyyy-MM-dd") {
  let formattedDate = null;
  if (isObjectValid(date)) {
    formattedDate = format(new Date(date), dateFormat);
  }
  return formattedDate;
}

export function parseDate(input) {
  if (!input) return null;
  if (input instanceof Date) return new Date(input);
  if (typeof input === "string") {
    // ISO rapide
    if (/^\d{4}-\d{2}-\d{2}/.test(input)) return new Date(input);
    // JJ/MM/AAAA
    const m = input.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) {
      const [, dd, mm, yyyy] = m;
      return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    }
  }
  return null;
}
